import React from 'react';

// The DS confirm-card as a component. FigmaPopup renders this same anatomy inline for modals;
// this is the standalone-page equivalent, so a page-level message does not have to restate the
// banner, the icon tile, the eyebrow and the Oswald title (and their dark-mode overrides).
//
// Body copy: use the `mcard-lead` class for the opening sentence and `mcard-text` for the rest.
// `actions` are laid out edge to edge, weighted toward the first (primary) one — a standalone
// card has no toolbar to sit in, so a left-packed row leaves dead space at its right edge.
export default function MessageCard({
  eyebrow = '',
  title = '',
  iconName = '',
  children = null,
  actions = null,
  className = '',
}) {
  return (
    <div className={('confirm-card mcard ' + className).trim()}>
      <div className='confirm-banner'></div>

      <div className='confirm-head'>
        {iconName ? (
          <div className='confirm-icon tone-navy'>
            <i className={iconName} />
          </div>
        ) : null}
        <div>
          {eyebrow ? <div className='eyebrow'>{eyebrow}</div> : null}
          {title ? <h2>{title}</h2> : null}
        </div>
      </div>

      <div className='confirm-body mcard-body'>{children}</div>

      {actions ? <div className='confirm-foot mcard-foot'>{actions}</div> : null}
    </div>
  );
}
